"use strict";
var __importStar =
  (this && this.__importStar) ||
  function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null)
      for (var k in mod)
        if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
  };
Object.defineProperty(exports, "__esModule", { value: true });
const IValidation_1 = require("./IValidation");
const Yup = __importStar(require("yup"));
const helper_1 = require("./helper");
exports.jenkinsSchema = Yup.object()
  .shape({
    host: Yup.object().shape({
      url: Yup.string().required(),
      username: Yup.string().required(),
      apiToken: Yup.string().required()
    }),
    job: Yup.string().required(),
    data: Yup.object()
  })
  .required();
class JenkinsNodeValidation {
  validate(node) {
    let data = node.getNodeData();
    return helper_1.isValid(
      [
        { schema: exports.jenkinsSchema, data },
        { schema: IValidation_1.nodeSchema, data: node.serializeNode() }
      ],
      node.getNodeId()
    );
  }
}
exports.JenkinsNodeValidation = JenkinsNodeValidation;
//# sourceMappingURL=JenkinsNodeValidation.js.map
